import React from "react";

const ActualNoData = () => {
    return (
        <div className="text-center py-5">
            <div className="py-5">
                <i className="fa fa-database fa-4x text-muted mb-3"></i>
                <h5 className="text-muted">No Data Found</h5>
                <p className="text-muted">No records match your search criteria</p>
            </div>
        </div>
    )
}

export default ActualNoData;